module.exports = __webpack_public_path__ + "img/more-dots.6797a246.svg";